import classNames from 'classnames';

import styles from '../../PackagesRoomsAmenities.module.scss';

import type { EntityStatus } from './entity';

const LABELS: Record<EntityStatus, string> = {
  PUBLISHED: 'Published',
  UNPUBLISHED: 'Unpublished',
  HIDDEN: 'Hidden',
  DELETED: 'Deleted',
};

type Props = { status: EntityStatus };

export const EntityStatusBadge = ({ status }: Props) => (
  <div className={styles.status}>
    <span className={classNames(styles.dot, styles[status.toLowerCase()])} />
    {LABELS[status]}
  </div>
);
